import React from "react";
import MainLayout from "../../layouts/MainLayout";
import { Helmet } from "react-helmet-async";

const About = () => {
  return (
    <MainLayout>
      {/* Set SEO Metadata and Canonical Tag */}
        <Helmet>
          <title>About | paralegal.lk</title>
          <meta
            name="description"
            content="Paralegal builds AI-powered tools for Sri Lankan legal professionals — case law search, consolidated legislation, tri-lingual legal translation, and an AI research platform."
          />
          <link rel="canonical" href="https://www.paralegal.lk/about" />
        </Helmet>

      <div className="flex flex-col justify-center mx-auto max-w-6xl mt-50 p-20 text-pl-text-primary">
        <h1 className="mb-6 font-display font-semibold text-18 md:text-22">
          Our Services
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <a
            href="https://www.paralegal.lk"
            className="block rounded-xl border border-pl-border p-6 md:col-span-2 hover:shadow-lg transition-shadow"
          >
            <h3 className="mb-3 font-bold text-16 md:text-18 text-pl-accent">
              paralegal.lk
            </h3>
            <p className="leading-relaxed mb-3">
              A comprehensive online platform dedicated to providing access to
              Sri Lankan legal resources. Over{" "}
              <span className="font-medium">20,000 appellate court decisions</span>{" "}
              dating back to <span className="font-medium">1880</span>.
            </p>
            <p className="leading-relaxed">
              Advanced search features including{" "}
              <span className="font-medium">Exact Search</span>,{" "}
              <span className="font-medium">AI Search</span>, and{" "}
              <span className="font-medium">Case Number Search</span> for
              quick and accurate retrieval of legal information.
            </p>
          </a>

          <a
            href="https://lex.paralegal.lk"
            className="block rounded-xl border border-pl-border p-6 hover:shadow-lg transition-shadow"
          >
            <h3 className="mb-3 font-bold text-16 md:text-18 text-pl-accent">
              lex.paralegal.lk
            </h3>
            <p className="leading-relaxed">
              A free consolidated legislation search engine for Sri Lanka,
              making it easy to find and navigate statutes and legislative
              provisions.
            </p>
          </a>

          <a
            href="https://translate.paralegal.lk"
            className="block rounded-xl border border-pl-border p-6 hover:shadow-lg transition-shadow"
          >
            <h3 className="mb-3 font-bold text-16 md:text-18 text-pl-accent">
              translate.paralegal.lk
            </h3>
            <p className="leading-relaxed">
              A specialised tri-lingual translator built for Sri Lankan legal
              documents, including scanned ones.{" "}
              <span className="font-medium">Rs. 2,000 in free credits</span> on
              sign up, then{" "}
              <span className="font-medium">Rs. 0.25 per word</span>.
            </p>
          </a>

          <a
            href="https://chat.paralegal.lk"
            className="block rounded-xl border border-pl-border p-6 md:col-span-2 hover:shadow-lg transition-shadow"
          >
            <h3 className="mb-3 font-bold text-16 md:text-18 text-pl-accent">
              chat.paralegal.lk
            </h3>
            <p className="leading-relaxed mb-3">
              An AI-powered platform for legal work, featuring a{" "}
              <span className="font-medium">Deep AI Legal Research Assistant</span>,{" "}
              <span className="font-medium">OCR and intelligent file search</span>{" "}
              across documents,{" "}
              <span className="font-medium">web search</span>, and access to the{" "}
              <span className="font-medium">latest GPT models</span> for legal
              drafting and analysis.
            </p>
            <p className="leading-relaxed text-sm opacity-75">
              Coming soon: research over regulations and gazettes, contract
              drafting, contract redlining and due diligence, and translation.
            </p>
          </a>
        </div>

        <p className="leading-relaxed mt-8">
          For inquiries, please contact us at{" "}
          <a
            href="mailto:admin@paralegal.lk"
            className="hover:underline text-pl-accent"
          >
            admin@paralegal.lk
          </a>
        </p>
      </div>
    </MainLayout>
  );
};

export default About;
